import React from 'react'
import BodyCard from '../atoms/BodyCard'
import BodyHeader from '../molecules/BodyHeader'
import CardLeftRight from '../molecules/CardLeftRight'
import ListHeader from '../molecules/ListHeader'
import TitleSubtitle from '../molecules/TitleSubtitle'
import Zone from '../organisms/Zone'
import useDefault from '../../hooks/useDefault'

import useContact from '../../hooks/useContact'
import { Box, Skeleton, Typography } from '@mui/material'
import { SERVICES } from '../../constants'

const Contact = () => {
	const { isLoading, title, content, phone, email } = useContact()
	const { data: animations } = useDefault(SERVICES.ANIMATION)

	return (
		<>
			{(isLoading && <Skeleton />) || (
				<BodyHeader title={title} infoLabel1={phone} infoLabel2={email} hasContactForm>
					{content}
				</BodyHeader>
			)}
			<Zone color="ivory" pt={34}>
				<TitleSubtitle
					title="Infos pratiques"
					subtitle="Vous souhaitez nous donner des objets ou acheter seconde-main ?"
				/>
				<ListHeader />
				{animations &&
					animations?.list?.map(({ title, content, srcset, image }, index) => (
						<Box key={index}>
							<CardLeftRight src={srcset} image={image} hasRightTitle>
								<Typography component="h6" sx={{ fontSize: 32, fontWeight: 700 }}>
									{title}
								</Typography>
								<BodyCard>
									<Typography
										variant="div"
										component="div"
										dangerouslySetInnerHTML={{ __html: content }}
									/>
								</BodyCard>
							</CardLeftRight>
						</Box>
					))}
			</Zone>
		</>
	)
}

export default Contact
